import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from "../Auth/autoContext";
import LanguageDropdown from '../Components/languageDropDown';
import type { UserProfile } from '../Data/typeusers';
import { FaUser, FaBars, FaTimes } from 'react-icons/fa';
import { clearAllCache } from "../Data/dataCache";

const Header: React.FC = () => {
    const [isLogin, setIsLogin] = useState<boolean>(false);
    const [user, setUser] = useState<UserProfile | null>(null);
    const { role, logout } = useAuth();
    const [menuOpen, setMenuOpen] = useState(false);

    const { t } = useTranslation();

    const handleLogin = () => {
        const token = sessionStorage.getItem('token');
        const user = sessionStorage.getItem('user');
        if (token && user) {
            const userParsed: UserProfile = JSON.parse(user);
            setUser(userParsed);
            setIsLogin(true);
        } else {
            setUser(null);
            setIsLogin(false);
        }
    };

    const handleLogout = () => {
        sessionStorage.clear();
        clearAllCache();
        
        logout();
        setUser(null);
        setIsLogin(false);
        window.location.href = "/";
    };

    useEffect(() => {
        handleLogin();
    }, []);

    useEffect(() => {
        const handleRefresh = () => handleLogin();
        window.addEventListener('refresh-login', handleRefresh);
        return () => window.removeEventListener('refresh-login', handleRefresh);
    }, []);

    const forecastsLink =
        role === 'premium'
            ? "/forecasts"
            : role === 'public'
                ? "/upgradePremium"
                : "/registerForm";

    const forecastsState =
        role === 'premium' || role === 'public'
            ? undefined
            : { isPrevisionLink: true };

    return (
        <header className="header">
            {/* 🔹 TOP BAR */}
            <div className="header-top">
                <Link to="/" className="logo">Stockifly</Link>

                <div className="top-right">
                    
                    {/* Burger */}
                    <button className="burger" onClick={() => setMenuOpen(!menuOpen)}>
                        {menuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
                    </button>

                </div>
            </div>

            {/* 🔹 MENU */}
            <div className={`header-menu ${menuOpen ? "open" : ""}`}>

                {/* NAV */}
                <nav className="nav-links">
                    <Link to="/list" onClick={() => setMenuOpen(false)}>
                        {t('header.list')}
                    </Link>

                    <Link
                        to={forecastsLink}
                        state={forecastsState}
                        onClick={() => setMenuOpen(false)}
                    >
                        {t('header.forecasts')}
                    </Link>

                    <Link
                        to="/favorites"
                        onClick={() => setMenuOpen(false)}
                    >
                        {t("header.favorites")}
                    </Link>
                </nav>

                {/* AUTH */}
                <div className="auth-section">
                    {!isLogin ? (
                        <>
                            <Link to="/login" onClick={() => setMenuOpen(false)}>
                                <button className="button-blue">
                                    {t('header.buttons.login')}
                                </button>
                            </Link>

                            <Link to="/registerForm" onClick={() => setMenuOpen(false)}>
                                <button className="button-gray">
                                    {t('header.buttons.register')}
                                </button>
                            </Link>
                        </>
                    ) : (
                        <>
                            {role !== 'premium' && (
                                <Link to="/upgradePremium" onClick={() => setMenuOpen(false)}>
                                    <button className="button-blue">
                                        {t('header.upgrade')}
                                    </button>
                                </Link>
                            )}

                            <div className="dropdown">
                                <button className="dropbtn">
                                    <span>
                                        {t('header.welcome')} {user?.firstName}
                                    </span>

                                    <FaUser />
                                </button>

                                <div className="dropdown-content">

                                    <Link to="/profile" onClick={() => setMenuOpen(false)}>
                                        {t('header.menu.profile')}
                                    </Link>

                                    <button
                                        className="dropdown-logout"
                                        onClick={handleLogout}
                                    >
                                        {t('header.menu.logout')}
                                    </button>

                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
                {/* LANGUAGE DESKTOP */}
                <div className="lang-section">
                    <LanguageDropdown onSelectLanguage={() => setMenuOpen(false)} />
                </div>
        </header>
    );
};

export default Header;